module.exports = __webpack_public_path__ + "img/security.9dbecbec.svg";